module.exports = __webpack_public_path__ + "static/media/39.028f3f82.png";